
function EmailInfoCtrl(TranslationService) {
    var ctrl = this;

    ctrl.expanded = true;
    ctrl.maxErrors = 100;
    ctrl.numErrors = ctrl.maxErrors;
    //this.close = function () {
    //    ctrl.errors = [];
    //}

    this.toggle = function () {
        ctrl.expanded = !ctrl.expanded;
        if (ctrl.expanded) {
            ctrl.numErrors = ctrl.maxErrors
        }
        else {
            ctrl.numErrors = 1;
        }
    }

    this.hasErrors = function () {
        if (!ctrl.errors) {
            return false
        }
        return ctrl.errors.length || ctrl.errorMsg != '';
    }

}

EmailInfoCtrl.$inject = ['TranslationService'];

seedWebApp.component('emailErrors', {
    controller: EmailInfoCtrl,
    controllerAs: 'ctrl',
    bindings: {
        title: '<',
        errorMsg: '<',
        errors: '=',        
        showCollapse: '<'
    },
    templateUrl: '/SPA/logistics/email-errors.html' + seedWebApp.buildVersion
});